import { render, staticRenderFns } from "./InboxMailList.vue?vue&type=template&id=21e8e88c&scoped=true"
import script from "./InboxMailList.vue?vue&type=script&lang=js"
export * from "./InboxMailList.vue?vue&type=script&lang=js"
import style0 from "./InboxMailList.vue?vue&type=style&index=0&id=21e8e88c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21e8e88c",
  null
  
)

export default component.exports